import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
// import { createLogger } from 'redux-logger';
import rootReducer from '../reducers';

import { SSR } from '../../utils/config';

// const loggerMiddleware = createLogger();
const defaultState = {
  getHome: {},
  getPastConcerts: {},
  getConcerts: {},
  getConcert: {},
  getArtists: {},
  getPress: {},
  getPressInner: {},
  getNews: {},
  getNewsListing: {},
  getAboutData: {},
  getFAQ: {},
  getUsefulContacts: {},
  getSponsors: {},
  getSettingsData: {},
  getDonationData: {},
  getSearchResults: {},
  getMeta: {},
};
export const MyStore = (initialState) =>
  createStore(
    rootReducer,
    initialState || defaultState,
    compose(
      applyMiddleware(thunkMiddleware),
      (!SSR &&
        window.__REDUX_DEVTOOLS_EXTENSION__ &&
        window.__REDUX_DEVTOOLS_EXTENSION__()) ||
        compose
    )
  );
